import { render, staticRenderFns } from "./PrivacyInfoBody.vue?vue&type=template&id=2417c44e&scoped=true"
import script from "./PrivacyInfoBody.vue?vue&type=script&lang=js"
export * from "./PrivacyInfoBody.vue?vue&type=script&lang=js"
import style0 from "./PrivacyInfoBody.vue?vue&type=style&index=0&id=2417c44e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2417c44e",
  null
  
)

export default component.exports